import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';

import { RequestItem, Kv } from '../../../../state/integration-tester.models';
import { ItKvEditorComponent } from '../kv-editor/it-kv-editor.component';

@Component({
  selector: 'it-params-tab',
  standalone: true,
  templateUrl: './it-params-tab.component.html',
  styleUrls: ['./it-params-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, ItKvEditorComponent],
})
export class ItParamsTabComponent {
  @Input({ required: true }) request!: RequestItem;

  @Output() add = new EventEmitter<void>();
  @Output() updateKv = new EventEmitter<{ index: number; patch: Partial<Kv> }>();
  @Output() remove = new EventEmitter<{ index: number }>();
  @Output() clear = new EventEmitter<void>();
}
